import { z } from 'zod';

/**
 * @openapi
 * components:
 *   schemas:
 *     InviteUsersDto:
 *       type: object
 *       properties:
 *         emails:
 *           type: array
 *           items:
 *             type: string
 *           description: The emails of the users
 *       required:
 *         - emails
 */
export const inviteUsersDto = z.object({
  emails: z.array(z.string().email()).min(1).max(100),
  roleIds: z.array(z.string().uuid()).min(1),
});

export type InviteUsersDto = z.infer<typeof inviteUsersDto>;
